import config from '@config'
import script from '@lib/script'
import Sentry from '@lib/sentry'

// istanbul ignore next: cannot test locally
export const collectCheckoutComDeviceFingerprint = async (): Promise<string | null> => {
  try {
    await script.load(config.checkoutcom.riskSdk.url, tag => {
      tag.integrity = config.checkoutcom.riskSdk.integrity
      tag.crossOrigin = 'anonymous'
    })

    const riskInstance = await (window as any).Risk.create(config.checkoutcom.publicKey)
    const sessionId = await riskInstance.publishRiskData()

    return sessionId
  } catch (error) {
    Sentry.captureException(error, {
      tags: {
        component: 'checkoutComDeviceFingerprint',
        operation: 'collectDeviceFingerprint',
      },
    })
    return null
  }
}
